/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_NotificationsInputs */

const da_common_notifications = /** @type {(inputs: Common_NotificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beskeder`)
};

/** @type {(inputs: Common_NotificationsInputs) => LocalizedString} */
const en_common_notifications = da_common_notifications;

/**

* @param {Common_NotificationsInputs} inputs
* @param {{ locale?: "da" | "en" }} options
* @returns {LocalizedString}
*/
export const common_notifications = /** @type {((inputs?: Common_NotificationsInputs, options?: { locale?: "da" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_NotificationsInputs, { locale?: "da" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_common_notifications(inputs)
	return /** @type {LocalizedString} */ ("Beskeder")
});